<div
  *transloco="let t; scope: 'featureSearch'"
  class="flex flex-col items-center justify-center gap-4 py-16 text-center"
>
  <i class="ui-search-redo bd-empty-state-icon" aria-hidden="true"></i>
  <p class="bd-headline-small" data-id="empty-state-title">
    {{ t(titleKey()) }}
  </p>
  <p class="bd-body-regular bd-empty-state-description">
    <span data-id="empty-state-description">{{ t(descriptionKey()) }}</span>
    @if (links().length > 0) {
      <span data-id="empty-state-links">
        {{ t('featureSearch.tabEmptyState.linksIntro') }}
        @for (link of links(); track link.scope; let last = $last) {
          <button
            type="button"
            class="bd-empty-state-link"
            [attr.data-id]="'empty-state-link-' + link.scope"
            (click)="scopeSelected.emit(link.scope)"
          >
            {{ t(link.labelKey) }}</button
          >{{ last ? '.' : ' ' + t('featureSearch.tabEmptyState.or') + ' ' }}
        }
      </span>
    }
  </p>
  @if (actionButton() | translateActionButton | async; as action) {
    <p-button
      data-id="empty-state-action"
      [bdActionButton]="action"
      (onClick)="action.onClick($event)"
    ></p-button>
  }
</div>
